import EventTable from "components/eventTable";

function ICC2025() {
    return (
        <>
            <div className='relative w-full'>
                <div className="bg-[#fff] h-auto relative">
                    <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>
                        <a id="multiMarketPin" title="Remove from Multi Markets" className="cursor-pointer items-center bg-transparent border-[1px] border-[solid] border-[#045662] rounded-[3px] !text-[#fff] flex float-left text-[13px] h-[18px] justify-center -ml-[4px] mr-[3px] my-[0] w-[18px]" ><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>
                        <span className="max-w-[220px] lg:max-w-[465px] float-left m-0 overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">ICC Champions Trophy - Winner</span>
                    </p>
                </div>

                {/* <div className="bg-[#fff] text-[#000]">
                    <div className="bg-[#043c79]">
                        <div className="scorecard bg-[#03334a] text-[#fff] text-[16px] leading-[17px] p-[5px] relative w-full">
                            <div className="grid grid-cols-2 flex-wrap">
                                <div className="col-span-1 relative">
                                    <span className="text-[white] text-[12px] leading-[17px]" >
                                        <i className="flaticon-clock text-white" aria-hidden="true" ></i>
                                        14/02/2025 19:30
                                    </span>
                                </div>
                                <div className="col-span-1 relative">
                                    <span className="text-[white] float-right text-[12px]" > Min: 1 | Max: 1 </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="flex lg:hidden items-start bg-[#343a40] border-[#18adc580] border-b-[1px] gap-[2px] justify-around p-0 w-full matched_bet_box">
                    <div className="match_info_name active">
                        <span className="market-2">Market</span>
                        <div className="market market-1"></div>
                    </div>
                    <div className="match_info_name ">
                        <span className="market-2">
                            Open Bets
                            <span className="betcount">(0)</span>
                        </span>
                        <div className="market market-1"></div>
                    </div>
                </div> */}
                {/* <EventTable /> */}

            </div>
        </>
    );
}

export default ICC2025;